import React from 'react';
import { noop } from 'lodash';
import { node } from 'prop-types';
import { LazyComponent } from '@fiverr-private/orca';
import { personalizedSectionFetcher } from '../propTypes';
import { onDynamicImportError } from '../utils/errorHandling';
import { logger, extractRecommendationsParams } from '../../shared/logger';

const lazyImport = () => import(/* webpackChunkName: 'PersonalizedSectionFetcher' */ '../PersonalizedSectionFetcher');

const LazyPersonalizedSectionFetcher = ({
    placeholder,
    fallback,
    onFetchSucceeded = noop,
    onFetchFailed = noop,
    ...personalizedProps
}) => {
    logger.setLoggerConsumerData(extractRecommendationsParams(personalizedProps));

    const onError = (error) => {
        const { funnelName, pageName } = personalizedProps?.recommendationsParams ?? {};
        const logMessage = 'Failed to lazy load PersonalizedSectionFetcher';

        onDynamicImportError({ stackTrace: error, logMessage, funnelName, pageName });
    };

    const componentProps = {
        ...personalizedProps,
        onFetchSucceeded: (...data) => {
            onFetchSucceeded(...data);
        },
        onFetchFailed: (...data) => {
            onFetchFailed(...data);
        },
        placeholder,
    };

    return (
        <LazyComponent
            lazyImport={lazyImport}
            fallback={fallback}
            placeholder={placeholder}
            componentProps={componentProps}
            onError={onError}
        />
    );
};

LazyPersonalizedSectionFetcher.propTypes = {
    placeholder: node,
    fallback: node,
    ...personalizedSectionFetcher,
};

export default LazyPersonalizedSectionFetcher;
